import setup from "./setup";
setup();

import makeChart from "./beeswarm";

import cpiData from "../data/cpiData.json";
import combinedData from "../data/combinedData.json";
import cesData from "../data/cesData.json";
import lowIncomeData from "../data/cpiLowIncome.json";

function main() {

  const theChart = new makeChart({
    element: document.querySelector(".chart"),
    data: cpiData
  });

  window.addEventListener("optimizedResize", () => {
    theChart.update();
  });

}
window.onload = main;
